import VesselAPI from './vessel.api'

export default VesselAPI
